import { render, staticRenderFns } from "./WorkoutSplitOverviewAndSubmit.vue?vue&type=template&id=39e2b6d9&scoped=true"
import script from "./WorkoutSplitOverviewAndSubmit.vue?vue&type=script&lang=js"
export * from "./WorkoutSplitOverviewAndSubmit.vue?vue&type=script&lang=js"
import style0 from "./WorkoutSplitOverviewAndSubmit.vue?vue&type=style&index=0&id=39e2b6d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e2b6d9",
  null
  
)

export default component.exports